/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Church = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m18 7 4 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9l4-2" }],
    ["path", { d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4" }],
    ["path", { d: "M18 22V5l-6-3-6 3v17" }],
    ["path", { d: "M12 7v5" }],
    ["path", { d: "M10 9h4" }]
  ]
];

export { Church as default };
//# sourceMappingURL=church.js.map
